import { captureException } from '@sentry/browser'
import { ErrorGeneral } from '@tunasong/tunasong-ui'
import { useEffect } from 'react'
import type { FC } from 'react'
import { useRouteError } from 'react-router'

/**
 * The router's `errorElement` (GH #2824): the crash page for the error of the route that failed, such as a loader
 * error or a lazy route chunk that no longer exists after a deploy (Reload fixes that).
 *
 * React Router renders it in place of the route, with no children, so it reads the error with `useRouteError()`.
 * The class boundary it replaces only caught its own children: here it rendered nothing, and reported nothing.
 */
const RouteErrorBoundary: FC = () => {
  const error = useRouteError()

  useEffect(() => {
    captureException(error)
  }, [error])

  return <ErrorGeneral error={error} />
}

export default RouteErrorBoundary
